import React, { useState, useEffect } from "react";
import "./SessionExpiredMessage.scss";
import { Button, Modal, Form } from 'antd';
import { useTranslation } from "react-i18next";

import axios from "axios";

function SessionExpiredMessage(props) {
    const {t} = useTranslation();
    const [modalShown, setModalShown] = useState(false);
    let timer;

    useEffect(() => {
            initTimer();
            return () => {
                resetTimer();
            }
        },[]);

    const showModal = () => {
        setModalShown(true);
    };

    axios.interceptors.response.use(
        (response) => {
            return response;
        },
        (error) => {
            try {
                if (error.response.status === 401) {
                    showModal();
                }

                if(error.response.config.url === "/api/support/app/version") {
                    if (error.response.status >= 500 && error.response.status < 600) {
                        showModal();
                    }
                }

            } catch(err){
                window.location.reload();
            }
            return Promise.reject(error);
        }
    );

    const tick = () => {
        axios.get("/api/support/app/version",
                    { headers: { "X-Requested-With": "XMLHttpRequest" }, withCredentials: true }
                )
            .then( x => initTimer() )
            .catch( function(error) {
                showModal();
            });
    };

    const initTimer = () => {
        timer = setTimeout(() => {
            resetTimer();
            tick();
        }, 30000); // 30000ms = 30secs.
    };

    const resetTimer = () => {
        if (timer) {
            clearTimeout(timer);
        }
    };


    return (
        <>
            <Modal
                className="modal-session-expired-message"
                style={{ top: 160 }}
                visible={modalShown}
                footer={null}
            >
                <p>{t('common.errors.sessionExpired')}</p>

                <div className="controls">
                    <Button type="primary" onClick={props.logout}>
                            OK
                    </Button>
                </div>
            </Modal>
        </>
    );
}

export default Form.create()(SessionExpiredMessage);
